import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const CSS_Ordered_List = () => {
  return (
    <div className="tutorial-container">
      <h1 className="tutorial-title">📑 CSS Ordered Lists</h1>

      <p className="tutorial-intro">
        Ordered lists are defined with the <code>&lt;ol&gt;</code> tag. Each
        list item is wrapped in <code>&lt;li&gt;</code>. By default, ordered
        lists display items with numbers (1, 2, 3...), but CSS allows you to
        change the numbering style, spacing, and appearance.
      </p>

      {/* Section 1 */}
      <div className="tutorial-section">
        <h2 className="section-title">🔹 Default Numbering</h2>
        <p>
          By default, browsers display ordered lists with numbers. For example:
        </p>

        <CodeCopyBlock
          code={`<ol>
  <li>Apples</li>
  <li>Bananas</li>
  <li>Cherries</li>
</ol>`}
        />

        <div style={{ marginTop: "1rem" }}>
          <ol
            style={{
              background: "#f0fdf4",
              padding: "15px 30px",
              borderRadius: "8px",
              border: "1px solid #bbf7d0",
            }}
          >
            <li>Apples</li>
            <li>Bananas</li>
            <li>Cherries</li>
          </ol>
        </div>
      </div>

      {/* Section 2 */}
      <div className="tutorial-section">
        <h2 className="section-title">🔹 Roman Numerals</h2>
        <p>
          You can use <code>list-style-type: upper-roman;</code> to change the
          numbers into Roman numerals:
        </p>

        <CodeCopyBlock
          code={`ol {
  list-style-type: upper-roman;
}`}
        />

        <div style={{ marginTop: "1rem" }}>
          <ol
            style={{
              listStyleType: "upper-roman",
              background: "#eff6ff",
              padding: "15px 30px",
              borderRadius: "8px",
              border: "1px solid #bfdbfe",
              color: "#1e3a8a",
            }}
          >
            <li>HTML</li>
            <li>CSS</li>
            <li>JavaScript</li>
          </ol>
        </div>
      </div>

      {/* Section 3 */}
      <div className="tutorial-section">
        <h2 className="section-title">🔹 Alphabetical</h2>
        <p>
          CSS also lets you use alphabetic numbering. Example with{" "}
          <code>list-style-type: lower-alpha;</code>:
        </p>

        <CodeCopyBlock
          code={`ol {
  list-style-type: lower-alpha;
}`}
        />

        <div style={{ marginTop: "1rem" }}>
          <ol
            style={{
              listStyleType: "lower-alpha",
              background: "#fff7ed",
              padding: "15px 30px",
              borderRadius: "8px",
              border: "1px solid #fed7aa",
              color: "#9a3412",
            }}
          >
            <li>First Step</li>
            <li>Second Step</li>
            <li>Third Step</li>
          </ol>
        </div>
      </div>

      {/* Section 4 */}
      <div className="tutorial-section">
        <h2 className="section-title">🔹 Nested Ordered Lists</h2>
        <p>
          You can also nest ordered lists inside each other, each having its own
          numbering style:
        </p>

        <CodeCopyBlock
          code={`<ol>
  <li>Frontend
    <ol type="a">
      <li>HTML</li>
      <li>CSS</li>
    </ol>
  </li>
  <li>Backend</li>
</ol>`}
        />

        <div style={{ marginTop: "1rem" }}>
          <ol
            style={{
              background: "#faf5ff",
              padding: "15px 30px",
              borderRadius: "8px",
              border: "1px solid #e9d5ff",
              color: "#6b21a8",
            }}
          >
            <li>
              Frontend
              <ol
                type="a"
                style={{
                  marginTop: "8px",
                  paddingLeft: "20px",
                  listStyleType: "lower-alpha",
                  color: "#9333ea",
                }}
              >
                <li>HTML</li>
                <li>CSS</li>
              </ol>
            </li>
            <li>Backend</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default CSS_Ordered_List;
